import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { useTranslation } from 'next-i18next/pages'
import UspsFairPrice from 'features/usps/fair-price/UspsFairPrice'

const UspFairPricePage = () => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'price' })

  // Constants
  const seo: SeoProps = {
    title: t('seo.title'),
    description: t('seo.description')
  }

  return (
    <Layout {...{ seo }}>
      <UspsFairPrice />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'usps'], i18nConfig))
    }
  }
}

export default UspFairPricePage
